package com.neurobs.js.dom

import org.scalajs.dom.raw.HTMLElement
import scalatags.JsDom.all._

class VideoElement (elementClass: String, initialWidthPixels: Int = 0, initialHeightPixels: Int = 0) {
	private var widthPixels = initialWidthPixels
	private var heightPixels = initialHeightPixels
	private var currentPercent: Double = 1

	val element: HTMLElement = div(`class` := elementClass).render

	def adjustRatio(ratioWidth: Int, ratioHeight: Int): Unit = {
		widthPixels = (heightPixels * ratioWidth / ratioHeight.toDouble).toInt
		resize(currentPercent)
	}

	def adjustPercent(difference: Double): Unit = {
		if (currentPercent + difference > 0.1) {
			resize(currentPercent + difference)
		}
	}

	def resize(percent: Double): Unit = {
		element.style.width = widthPixels * percent + "px"
		element.style.height = heightPixels * percent + "px"
		currentPercent = percent
	}
	def setSize(widthPx: Int, heightPx: Int): Unit = {
		widthPixels = widthPx
		heightPixels = heightPx
		resize(percent = 1)
	}

	resize(percent = currentPercent)
}